import React from "react";
import "../App.css";

export default function Navbar() {
  return (
    <nav className={`flex justify-around items-center py-1`}>
      <div className="flex justify-center items-center w-1/3">
        <img
          className="border-2 border-white rounded-full   w-12"
          src="https://nash.gallerycdn.vsassets.io/extensions/nash/awesome-flutter-snippets/3.0.3/1642960640862/Microsoft.VisualStudio.Services.Icons.Default"
          alt=""
        />
        <h1 className="lg:text-2xl font-bold mx-4 dark:text-white">
          Vs Code Snippets
        </h1>
      </div>
    </nav>
  );
}
